import { Component, EventEmitter, Input, Output, OnInit, ChangeDetectorRef  } from "@angular/core";
import { TreeNode } from "primeng/api";
import { IdName } from "../domain/idname";
import { AccountService } from "../service/account.service";

@Component({
    selector: "modal-filter-picker",
    templateUrl: "./modal-filter-picker.component.html"
})
export class ModalFilterPickerComponent implements OnInit {
    constructor(
        private accountService: AccountService,
        private cdr: ChangeDetectorRef 
    ) {
        this.tableColumns = [{ field: "name", header: "Name", width: "100%" }];
    }

    @Input() reportId: number;
    @Input() filterAccounts: IdName[];

    @Output() change: EventEmitter<IdName[]> = new EventEmitter<IdName[]>();

    displayFilter: boolean = false;
    accountsForFilterExist: boolean;
    accountsForFilter: TreeNode[];
    selectedInFilter: TreeNode[] = [];
    tableColumns: any[];
    filterIds: string;
    loading: boolean = false;

    ngOnInit() {}

    setFilterIds(accounts: IdName[]) {
        this.filterIds = "";
        var filterIdsArray: number[] = [];
        if (accounts) {
            accounts.forEach((element) => {
                filterIdsArray.push(element.id);
            });
        }
        this.filterIds = filterIdsArray.join(",");
    }

    openFilterPicker() {
        this.loading = true;
        this.displayFilter = true;

        this.setFilterIds(this.filterAccounts);

        this.accountService
            .getAllForFilterList(this.reportId.toString(), this.filterIds)
            .then((accounts) => {
                this.accountsForFilter = accounts;
                this.accountsForFilterExist =
                    this.accountsForFilter && this.accountsForFilter.length > 0
                        ? true
                        : false;
                this.loading = false;
            });
    }

    addAccountToFilter() {
        if (this.filterAccounts === undefined) {
            this.filterAccounts = Array<IdName>();
        }

        if (!Array.isArray(this.selectedInFilter))
        {
            var newArray = new Array<TreeNode>();
            newArray.push(this.selectedInFilter);
            this.selectedInFilter = newArray;
        }

        this.selectedInFilter.forEach((element) => {
            let chip = new IdName();
            chip.id = element.data.id;
            chip.name = element.data.code;
            chip.desc = element.data.name;
            this.filterAccounts.push(chip);
        });

        this.selectedInFilter = [];
        this.displayFilter = false;
        console.log(this.filterAccounts);
        this.cdr.detectChanges();
    }

    removeAccounts(id) {
       
        this.filterAccounts = this.filterAccounts.filter((chip) => {
            return chip.id !== id;
        });
        this.change.emit(this.filterAccounts);
    }
    removeAccount() {
        this.change.emit(this.filterAccounts);
    }

}
